import React from 'react';
import { connect } from 'react-redux';
import Button from '../global/button';
import TranslatedCopy from '../../intl/translated-copy';
import Pictogram from '../global/pictogram';
import { enrollmentServiceErrorSuccess } from '../../../redux/actions';

const UserProfileRegistrationConnectionError = (props) => {
  const {
    closeModalLogin,
    dispatch,
    enrollmentServiceError,
    handleActiveRegistration,
    otpServiceError,
    getOtpError,
  } = props;

  const handleButtonOnClick = () => {
    const btnValue = enrollmentServiceError  || otpServiceError || getOtpError ? 'RETRY' : '';
    dispatch(enrollmentServiceErrorSuccess());

    if (btnValue === 'FATAL') {
      closeModalLogin();
    }
    if (btnValue === 'RETRY') {
      handleActiveRegistration();
    }
  };
  return (
    <div className='UserProfileRegistrationConnectionError-container'>
      {/* Back Button */}
      { enrollmentServiceError === 'RETRY' || getOtpError === '17331314' &&
      <button
        className='backButton'
        onClick={ handleButtonOnClick }>
        <span className='Icon Icon--calendarArrowLeft' />
        <TranslatedCopy
          className='copy-backButton'
          copyID='CC_TO_RETURN'
        />
      </button>
      }
      {/* body */}
      <div className='body'>
        <Pictogram
          className='Icon'
          id='incorrectInformation'/>
        <div className='content'>
          <div className='content-header'>
            <TranslatedCopy
              className='copy-backButton'
              copyID='PRO_HOME2.0_ERROR_WERE_SORRY'
            />
          </div>
          <div className='content-body'>
            <TranslatedCopy
              className='copy-backButton'
              copyID='PRO_HOME2.0_ERROR_DESCRIPTION'
            />
          </div>
        </div>
      </div>
      {/* Retry Button */}
      <Button
        className='Btn'
        copyID={ enrollmentServiceError === 'RETRY' || getOtpError === '17331314' ? 'CC_RETRY' : 'CC_ACCEPT' }
        onBtnClick={ handleButtonOnClick }
      />
    </div>
  );
};
const mapStateToProps = state => {
  return ({
    enrollmentServiceError: state.Login.enrollmentServiceError,
    otpServiceError: state.UserProfileSession.otpServiceError,
  });
};
export default connect(mapStateToProps)(UserProfileRegistrationConnectionError);